import styled from 'styled-components';

import { NewStyleColor } from '../../../../utils/styles-constants';

interface StyledMediaRndProps {
	isActive: boolean;
	outlineWidth: number;
}

const StyledMediaRnd = styled('div')`
	pointer-events: auto;

	${(props: StyledMediaRndProps) => props.isActive && `
		z-index: -1;

		img {
			outline: ${props.outlineWidth}px solid ${NewStyleColor.Blue100};
		}

		.editor-media-controls div {
			&::before,
			&::after {
				content: '';
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}

			&::before {
				width: 400%;
				height: 400%;
			}

			&::after {
				width: 100%;
				height: 100%;
				outline: 1px solid ${NewStyleColor.Blue100};
				background-color: ${NewStyleColor.White};
			}
		}
	`}
`;

export { StyledMediaRnd };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/MediaEditor/MediaRnd/styles.ts